<template>
	<Services v-if="Channel.Type === 'Services'" />
	<Query v-else />
</template>

<script>
	import Query from "./query.vue";
	import Services from "./services.vue";
	import baseMixin from "../mixins/base";

	export default {
		mixins: [baseMixin],
		components: {
			Query,
			Services,
		}
	}
</script>